function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M8.426 7l4.279-4.278a1.008 1.008 0 10-1.427-1.427L7 5.574 2.721 1.295a1.008 1.008 0 10-1.426 1.427L5.574 7l-4.279 4.278a1.008 1.008 0 001.426 1.427L7 8.426l4.278 4.279a1.008 1.008 0 101.427-1.427L8.426 7z",
  fill: "#fff",
  stroke: "#fff"
});

var SvgIconCloseWhite = function SvgIconCloseWhite(props) {
  return React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTguNDI2IDdsNC4yNzktNC4yNzhhMS4wMDggMS4wMDggMCAxIDAtMS40MjctMS40MjdMNyA1LjU3NCAyLjcyMSAxLjI5NWExLjAwOCAxLjAwOCAwIDEgMC0xLjQyNiAxLjQyN0w1LjU3NCA3bC00LjI3OSA0LjI3OGExLjAwOCAxLjAwOCAwIDAgMCAxLjQyNiAxLjQyN0w3IDguNDI2bDQuMjc4IDQuMjc5YTEuMDA4IDEuMDA4IDAgMSAwIDEuNDI3LTEuNDI3TDguNDI2IDd6IiBmaWxsPSIjZmZmIiBzdHJva2U9IiNmZmYiLz48L3N2Zz4=";
export { SvgIconCloseWhite as ReactComponent };